var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircularGreenCheck(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#3AA203"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.1576 30.0472C49.6148 29.5917 50.232 29.3353 50.8758 29.3335C51.5195 29.3317 52.1381 29.5847 52.5978 30.0376C53.0575 30.4906 53.3214 31.1072 53.3323 31.7542C53.3433 32.4011 53.1005 33.0264 52.6564 33.4949L39.615 49.8797C39.3909 50.1224 39.1204 50.3171 38.8196 50.4523C38.5189 50.5875 38.1941 50.6603 37.8648 50.6664C37.5354 50.6725 37.2082 50.6118 36.9027 50.488C36.5972 50.3641 36.3197 50.1796 36.0868 49.9454L27.4458 41.2572C27.2051 41.0317 27.012 40.7598 26.8781 40.4578C26.7442 40.1557 26.6722 39.8296 26.6664 39.4989C26.6606 39.1683 26.7211 38.8398 26.8443 38.5332C26.9676 38.2265 27.151 37.948 27.3837 37.7141C27.6163 37.4803 27.8935 37.2959 28.1985 37.1721C28.5036 37.0482 28.8304 36.9874 29.1594 36.9932C29.4884 36.999 29.8128 37.0714 30.1134 37.206C30.4139 37.3406 30.6844 37.5347 30.9088 37.7766L37.7496 44.6491L49.0955 30.1194C49.1158 30.094 49.1376 30.0698 49.1609 30.0472H49.1576Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircularGreenCheck);
export default __webpack_public_path__ + "static/media/circular-green-check.615e592ab61ccd0fe87d3abbb1545e7c.svg";
export { ForwardRef as ReactComponent };